import currency from "currency.js"

export default function TicketMaster(mid, cash, credit, tax, fee, feeTax, discount, tip, command = "Reef Pay", status = "OPEN") {
  this.mid = mid
  // this.ticketNumber = ""
  this.cash = currency(cash).value
  this.cashTax = currency(tax).value
  this.cashTotal = currency(cash + tax + tip).value
  // this.cashDiscount = 0
  this.credit = currency(credit).value
  this.creditTax = currency(tax + feeTax).value
  this.creditTotal = currency(credit + tax + feeTax + tip).value
  // this.creditDiscount = 0
  // this.taxRate = 0
  this.fee = currency(fee).value
  this.feeTax = currency(feeTax).value
  this.discountApplied = currency(discount).value
  this.tip = currency(tip).value
  this.status = status
  this.command = command
  this.payment = []
  this.details = []

  this.resolveDocument = function() {
    return {
      mid: this.mid,
      cash: currency(this.cash).intValue,
      cashTax: currency(this.cashTax).intValue,
      cashTotal: currency(this.cashTotal).intValue,
      credit: currency(this.credit).intValue,
      creditTax: currency(this.creditTax).intValue,
      creditTotal: currency(this.creditTotal).intValue,
      fee: currency(this.fee).intValue,
      feeTax: currency(this.feeTax).intValue,
      discountApplied: currency(this.discountApplied).intValue,
      tip: currency(this.tip).intValue,
      command: this.command,
      status: this.status,
      payment: this.payment,
      details: this.details
    }
  }
}